import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { CustomLoading } from "@ippon/shared-components";
import { useOwnAccountRole } from "@/hooks/useOwnAccountRole";
import { canAccessOwnerOnly } from "./ownerAccess";

/**
 * オーナー専用ルート（請求・利用状況）。
 *
 * サイドバーからメニューを隠すだけでは URL 直打ちで到達できてしまうため、
 * ルート側でも同じ条件で遮断する。ロールは /auth/me 由来で PrivateRoute が取得済み。
 * 取得中に判定するとオーナーまで弾いてしまうため、確定するまで待つ。
 */
const OwnerRoute: React.FC = () => {
  const { accountRole, loading } = useOwnAccountRole();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CustomLoading loading fullScreen={false} size="medium" />
      </Box>
    );
  }

  if (!canAccessOwnerOnly(accountRole)) {
    return <Navigate to="/setting/account" replace />;
  }

  return <Outlet />;
};

export default OwnerRoute;
